import React, { FC } from 'react';

import { Grid } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { DehydratedState } from '@tanstack/react-query';
import { AnimatePresence, domAnimation, LazyMotion, motion } from 'framer-motion';
import { NextComponentType, NextPageContext } from 'next';

import { useIsMobile } from '~components/hooks/utils/useIsMobile';
import { useAppStateContext } from '~components/providers/AppStateProvider';
import AppColors from '~components/theme/styles/colors';

export const AppViewport: FC<{
  Component: NextComponentType<NextPageContext, any, any>;
  pageProps: {
    dehydratedState: DehydratedState;
  };
}> = ({ Component, pageProps }) => {
  const { currentRoute } = useAppStateContext();
  const isMobile = useIsMobile();

  return (
    <Grid
      item
      xs
      color={AppColors.neutralGrey[0]}
      sx={{ backgroundSize: 'cover', width: isMobile ? '100%' : undefined }}
    >
      <CssBaseline />
      <LazyMotion features={domAnimation}>
        <AnimatePresence exitBeforeEnter initial={false}>
          <motion.div
            key={currentRoute}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Component {...pageProps} />
          </motion.div>
        </AnimatePresence>
      </LazyMotion>
    </Grid>
  );
};
